import {
    GelContainerLite,
    GelBoxLayout,
    GelLabel,
    GelIcon,
} from
    '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';

const UnAuthorized = () => {
    const { global: { themeColorTextDanger } } = getGelTokens()

    return (
        <GelContainerLite gutter="xlarge">
            <GelBoxLayout space="auto">
                <GelLabel style={{ color: themeColorTextDanger }}>
                    <GelIcon color={themeColorTextDanger} name="AlertCircle" inline />
                    Looks like are not signed in or your session is terminated due to inactivity. Please login again using valid credentials</GelLabel>
            </GelBoxLayout>
        </GelContainerLite>
    );
}

export default UnAuthorized;